import axios from 'axios';
import {downloadFile} from "../../../utils/file/download";

export class InstrumentService {
    /**
     * Función que consulta al servicio en el back para obtener
     * la lista de todos los clientes.
     * @returns {Promise<unknown>} Lista con clientes.
     */
    getDataAforos() {
        return axios.get('/appapv/loadAforos.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    modifyInstrument(instrument) {
        return axios.put('/appapv/modifyInstrument.action', {}, {
            params: {
                idEmisora: instrument.idEmisora,
                isin: instrument.isin,
                idGSS: instrument.idGSS,
                cveAforo: instrument.cveAforoObj.aforoStr,
                cupon: instrument.cupon,
            }
        }).then(res => res.data);
    }

    updateAvailability(listInstrument) {
        return axios.put('/appapv/updateAvailability.action', {}, {
            params: {
                listInstrumentJson: JSON.stringify(listInstrument),
            }
        }).then(res => res.data);
    }

    exportInstrumentXLS() {
        return downloadFile('/appapv/exportInstrumentXLS.action');
    }


}